import { useRef } from "react";
import { AriaButtonProps, useButton } from "react-aria";
import { styled } from "styled-components";
import { Typography } from "components/typography";

interface Button extends AriaButtonProps {
  children: React.ReactElement<string>;
}

export const StyledLinkButton = ({ children, ...props }: Button) => {
  const buttonRef = useRef(null);
  const { buttonProps } = useButton(props, buttonRef);
  return (
    <StyledTextButton {...buttonProps}>
      <StyledTypography insensitive variant="body">
        {children}
      </StyledTypography>
    </StyledTextButton>
  );
};

const StyledTextButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  &:hover {
    background-color: ${({ theme }) => theme.COLORS.GRAY_LIGHT};
  }
`;

const StyledTypography = styled(Typography)`
  cursor: pointer;
  text-decoration: underline;
`;
